import { render, staticRenderFns } from "./RequestsSingle.vue?vue&type=template&id=33f35f84&scoped=true"
import script from "./RequestsSingle.vue?vue&type=script&lang=js"
export * from "./RequestsSingle.vue?vue&type=script&lang=js"
import style0 from "./RequestsSingle.vue?vue&type=style&index=0&id=33f35f84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f35f84",
  null
  
)

export default component.exports